import { Outlet, useNavigate } from "react-router-dom";
import { ErrorBoundary } from "@sentry/react";

import { useTranslation } from "react-i18next";
import { ErrorFallbackBase } from "../error/ErrorFallbackBase";
import { RefreshCw } from "lucide-react";

export function OrderingLayout() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  return (
    <ErrorBoundary
      fallback={
        <ErrorFallbackBase
          title={t("common.errors.ordering.title")}
          description={t("common.errors.ordering.description")}
          primaryAction={{
            label: t("common.errors.ordering.retry"),
            onClick: () => window.location.reload(),
          }}
          secondaryAction={{
            label: t("common.errors.ordering.goHome"),
            onClick: () => navigate("/"),
            variant: "outline",
          }}
          icon={<RefreshCw className="h-5 w-5 text-primary" />}
        />
      }
    >
      <Outlet />
    </ErrorBoundary>
  );
}
